import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../Views/HomeView.vue";
import LoanProgram from "../Views/LoanProgram.vue";
import Calculators from "../Views/Calculators.vue";
import Apply from "../Views/Apply.vue";
import InfoLinks from "../Views/InfoLinks.vue";
import ContactForm from "../Views/ContactForm.vue";
import ApplySave from "../Views/ApplySave.vue";
import RadiantView from "../Views/RadiantView.vue";
import { authGuard } from "@auth0/auth0-vue";
import apiService from "../api/api.service.js";

import CoBrandThemeLanding from "../Views/CoBrandThemeLanding.vue";
import CoBrandThemeClassic from "../Views/themes/CoBrandThemeClassic.vue";
import CoBrandThemeClassicSplit from "../Views/themes/CoBrandThemeClassicSplit.vue";
import CoBrandHearthside from "../Views/themes/CoBrandHearthside.vue";
import CoBrandBlueprint from "../Views/themes/CoBrandBlueprint.vue";
import CoBrandStudio from "../Views/themes/CoBrandStudio.vue";
import CoBrandTerracotta from "../Views/themes/CoBrandTerracotta.vue";

import CoBrandSplit from "../Views/themes/CoBrandSplit.vue";
import CoBrandMeridian   from "../Views/themes/CoBrandMeridian.vue";
import CoBrandOverlap    from "../Views/themes/CoBrandOverlap.vue";
import CoBrandFolio      from "../Views/themes/CoBrandFolio.vue";
import CoBrandDashboard  from "../Views/themes/CoBrandDashboard.vue";
import CoBrandArch       from "../Views/themes/CoBrandArch.vue";
import CoBrandPulse   from '../Views/themes/CoBrandPulse.vue'
import CoBrandLinen   from '../Views/themes/CoBrandLinen.vue'
import CoBrandGrove   from '../Views/themes/CoBrandGrove.vue'
import CoBrandGilt    from '../Views/themes/CoBrandGilt.vue'
import CoBrandCanvas  from '../Views/themes/CoBrandCanvas.vue'


const routes = [
  {
    path: "/cobrand",
    name: "CoBrandThemeLanding",
    component: CoBrandThemeLanding
  },
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/loanprograms",
    name: "loanprograms",
    component: LoanProgram,
  },
  {
    path: "/calculators",
    name: "calculators",
    component: Calculators,
  },
  {
    path: "/apply",
    name: "apply",
    component: Apply,
  },
  {
    path: "/applysave",
    name: "applysave",
    component: ApplySave,
    beforeEnter: authGuard
  },
  {
    path: "/info",
    name: "info",
    component: InfoLinks,
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactForm
  },
  {
    path: "/radiant",
    name: "radiant",
    component: RadiantView
  },
  {
    path: "/cobrand/classic",
    name: "CoBrandThemeClassic",
    component: CoBrandThemeClassic
  },
  {
    path: "/cobrand/classic-split",
    name: "CoBrandThemeClassicSplit",
    component: CoBrandThemeClassicSplit
  },
 {
    path: "/cobrand/hearthside",
    name: "CoBrandHearthside",
    component: CoBrandHearthside
  },
  {
    path: "/cobrand/blueprint",
    name: "CoBrandBlueprint",
    component: CoBrandBlueprint
  },
  {
    path: "/cobrand/studio",
    name: "CoBrandStudio",
    component: CoBrandStudio
  },
  {
    path: "/cobrand/terracotta",
    name: "CoBrandTerracotta",
    component: CoBrandTerracotta
  },
  {
    path: "/cobrand/split",
    name: "CoBrandSplit",
    component: CoBrandSplit
  },
   { path: "/cobrand/meridian",  name: "CoBrandMeridian",  component: CoBrandMeridian  },
  { path: "/cobrand/overlap",   name: "CoBrandOverlap",   component: CoBrandOverlap   },
  { path: "/cobrand/folio",     name: "CoBrandFolio",     component: CoBrandFolio     },
  { path: "/cobrand/dashboard", name: "CoBrandDashboard", component: CoBrandDashboard },
  { path: "/cobrand/arch",      name: "CoBrandArch",      component: CoBrandArch      },
{ path: '/cobrand/pulse',   component: CoBrandPulse   },
{ path: '/cobrand/linen',   component: CoBrandLinen   },
{ path: '/cobrand/grove',   component: CoBrandGrove   },
{ path: '/cobrand/gilt',    component: CoBrandGilt    },
{ path: '/cobrand/canvas',  component: CoBrandCanvas  },
];

const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});
const larFromQuery = params.lar;
const loinfo = await apiService.GetLOPage(larFromQuery);

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeResolve(async to => {
  if (to.name === "home" && loinfo.data.data[0].radiant) {
    return '/radiant?lar=' + larFromQuery;
  }
});

export default router;